export function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        fill="#28367B"
        d="M15 23.25H9c-5.43 0-7.75-2.32-7.75-7.75v-6c0-5.43 2.32-7.75 7.75-7.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H9c-4.61 0-6.25 1.64-6.25 6.25v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 5.43-2.32 7.75-7.75 7.75"
      ></path>
      <path
        fill="#28367B"
        d="M8.5 18.19c-.61 0-1.17-.22-1.58-.62-.49-.49-.7-1.2-.59-1.95l.43-3.01c.08-.58.46-1.33.87-1.74l7.88-7.88c1.99-1.99 4.01-1.99 6 0 1.09 1.09 1.58 2.2 1.48 3.31-.09.9-.57 1.78-1.48 2.68l-7.88 7.88c-.41.41-1.16.79-1.74.87l-3.01.43c-.13.03-.26.03-.38.03m8.07-14.14-7.88 7.88c-.19.19-.41.63-.45.89l-.43 3.01c-.04.29.02.53.17.68s.39.21.68.17l3.01-.43c.26-.04.71-.26.89-.45l7.88-7.88c.65-.65.99-1.23 1.04-1.77.06-.65-.28-1.34-1.04-2.11-1.6-1.6-2.7-1.15-3.87.01"
      ></path>
      <path
        fill="#28367B"
        d="M19.85 10.33c-.07 0-.14-.01-.2-.03a7.94 7.94 0 0 1-5.46-5.46.76.76 0 0 1 .52-.93c.4-.11.81.12.92.52.6 2.13 2.29 3.82 4.42 4.42.4.11.63.53.52.93-.09.34-.39.55-.72.55"
      ></path>
    </svg>
  );

};

export function RemoveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#FB6B7A"
        d="M14 4.487h-.053C10.42 4.133 6.9 4 3.412 4.353l-1.36.134a.503.503 0 0 1-.107-1l1.36-.134c3.547-.36 7.14-.22 10.74.134a.5.5 0 0 1 .447.546.494.494 0 0 1-.493.454"
      ></path>
      <path
        fill="#FB6B7A"
        d="M5.667 3.813c-.027 0-.053 0-.087-.006a.5.5 0 0 1-.406-.574l.146-.873c.107-.64.254-1.527 1.807-1.527h1.747c1.56 0 1.707.92 1.806 1.534l.147.866a.495.495 0 0 1-.406.574.495.495 0 0 1-.574-.407L9.7 2.533c-.093-.58-.113-.693-.82-.693H7.134c-.707 0-.72.093-.82.687l-.154.866a.5.5 0 0 1-.493.42M10.14 15.167H5.86c-2.326 0-2.42-1.287-2.493-2.327l-.433-6.713a.505.505 0 0 1 .466-.534.505.505 0 0 1 .534.467l.433 6.713c.073 1.014.1 1.394 1.493 1.394h4.28c1.4 0 1.427-.38 1.494-1.394l.433-6.713a.51.51 0 0 1 .533-.467.5.5 0 0 1 .467.534l-.433 6.713c-.074 1.04-.167 2.327-2.494 2.327"
      ></path>
      <path
        fill="#FB6B7A"
        d="M9.107 11.5h-2.22a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h2.22c.273 0 .5.227.5.5s-.227.5-.5.5M9.667 8.833H6.333a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h3.334c.273 0 .5.227.5.5 0 .274-.227.5-.5.5"
      ></path>
    </svg>
  );
};

export function ArrowLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="12"
      fill="none"
      viewBox="0 0 7 12"
    >
      <path
        fill="#808487"
        d="M.8 6c0-.467.18-.934.533-1.287L5.68.366a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .707L2.04 5.42a.82.82 0 0 0 0 1.16l4.347 4.346a.503.503 0 0 1 0 .707.503.503 0 0 1-.707 0L1.333 7.286A1.82 1.82 0 0 1 .8 6"
      ></path>
    </svg>
  );
}

export function ArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <rect width="24" height="24" fill="#fff" rx="5"></rect>
      <path
        fill="#808487"
        d="M15.2 11c0-.467-.18-.934-.533-1.287L10.32 5.366a.503.503 0 0 0-.707 0 .503.503 0 0 0 0 .707l4.347 4.347c.32.32.32.84 0 1.16l-4.347 4.346a.503.503 0 0 0 0 .707.503.503 0 0 0 .707 0l4.347-4.347c.353-.353.533-.82.533-1.286"
      ></path>
    </svg>
  );
}

export function DetailsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#3F74FF"
        d="M8 10.887a2.888 2.888 0 0 1 0-5.774 2.888 2.888 0 0 1 0 5.774m0-4.774A1.89 1.89 0 0 0 6.113 8 1.89 1.89 0 0 0 8 9.887 1.89 1.89 0 0 0 9.887 8 1.89 1.89 0 0 0 8 6.113"
      ></path>
      <path
        fill="#3F74FF"
        d="M8 14.013c-2.507 0-4.873-1.467-6.5-4.013-.707-1.1-.707-2.894 0-4 1.633-2.547 4-4.014 6.5-4.014S12.867 3.453 14.493 6c.707 1.1.707 2.893 0 4C12.867 12.546 10.5 14.013 8 14.013M8 2.986c-2.153 0-4.213 1.294-5.653 3.554-.5.78-.5 2.14 0 2.92 1.44 2.26 3.5 3.553 5.653 3.553s4.213-1.293 5.653-3.553c.5-.78.5-2.14 0-2.92-1.44-2.26-3.5-3.554-5.653-3.554"
      ></path>
    </svg>
  );
}

export function SortIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#646464"
        d="M6.966 4.98a.5.5 0 0 1-.353-.147L4.486 2.707 2.36 4.833a.503.503 0 0 1-.706 0 .503.503 0 0 1 0-.706l2.48-2.48a.5.5 0 0 1 .707 0l2.48 2.48a.503.503 0 0 1 0 .706c-.1.1-.227.147-.354.147"
      ></path>
      <path
        fill="#646464"
        d="M4.487 14.5a.504.504 0 0 1-.5-.5V2c0-.273.227-.5.5-.5s.5.227.5.5v12c0 .273-.227.5-.5.5"
      ></path>
      <path
        fill="#B9B9B9"
        d="M11.52 14.5a.5.5 0 0 1-.353-.147l-2.48-2.48a.503.503 0 0 1 0-.707.503.503 0 0 1 .706 0l2.127 2.127 2.127-2.126a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .706l-2.48 2.48a.5.5 0 0 1-.353.147"
      ></path>
      <path
        fill="#B9B9B9"
        d="M11.513 14.5a.504.504 0 0 1-.5-.5V2c0-.273.227-.5.5-.5s.5.227.5.5v12a.5.5 0 0 1-.5.5"
      ></path>
    </svg>
  );
};